import { useEffect, useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
import { models as actionsModels, makes as actionsMakes, log as actionsLog } from "../../store/actions";
import ApiModels from '../../api/models';
import ListWithControls from "../general/ListWithControls";

const { setSelectedMake } = actionsMakes;
const { setSelectedModel, getModels } = actionsModels;
const { addToLog } = actionsLog;

const ModelsAll = () => {

    let dispatch = useDispatch();

    let selectedMake = useSelector(store => store.makes.selectedMake);

    useEffect(() => {
        if (selectedMake.id == -1) {
            dispatch(setSelectedMake(makes[0]));
        }
    }, []);

    let selectedModel = useSelector(store => store.models.selectedModel);
    let makes = useSelector(store => store.makes.items);
    let items = useSelector(store => store.models.items);

    const [ modelToRename, setModelToRename ] = useState(null);

    useEffect(() => {
        dispatch(getModels(selectedMake.id));
    }, [selectedMake]);

    const selectMake = e => {
        const idMake = e.target.value;
        const make = makes.find(item => Number(item.id) === Number(idMake));
        dispatch(setSelectedMake(make));
        dispatch(setSelectedModel(null));
    };

    const selectModel = model => {
        setTimeout(() => {
            dispatch(setSelectedModel(model));
        }, 0);
    };

    const deleteModel = model => {
        let proceed = window.confirm(`Delete model: ${model.name} [${model.id}]?`);
        if (proceed) {
            ApiModels.delete(model.id).then(resp => {
                dispatch(addToLog(resp));
                dispatch(getModels(selectedMake.id));
                if (selectedModel.id == model.id) {
                    dispatch(setSelectedModel(null));
                }
            });
        }
    }

    const renameModel = (e, model) => {
        e.stopPropagation();
        let proceed = window.confirm(`Rename model: ${model.name} [${model.id}] to ${modelToRename.name}?`);
        if (proceed) {
            ApiModels.update({ id: model.id, oldName: model.name, newName: modelToRename.name }).then(resp => {
                dispatch(addToLog(resp));
                dispatch(getModels(selectedMake.id));
                setModelToRename(null);
            });
        }
    }

    return (
    <div className="border border-gray-700">
        <div className="text-lg p-2 bg-gray-900 flex items-center justify-between">
            All Models for 
            <select value={selectedMake.id} onChange={selectMake} className="text-sm px-2 py-1 my-0 bg-gray-800 border border-gray-700">
                {makes.map(make => {
                    return <option value={make.id} key={make.id}>{make.name}</option>
                })}
            </select>
        </div>
        <ListWithControls 
            items={items} 
            selected={selectedModel}
            fxSelectItem={selectModel} 
            fxRenameItem={renameModel} 
            fxDeleteItem={deleteModel}
            itemToRename={modelToRename}
            fxSetItemToRename={setModelToRename} />
    </div>
    );
}

export default ModelsAll;